import React, { useState, useEffect } from 'react';
import Layout from './Layout';
import "../assets/css/styles.table.css"
import Box from '@mui/material/Box';
import DynamicDataGridComponent from '../components/DynamicDataGrid.js'
import GridNumberPaging from '../components/GridNumberPaging.js'
import DynamicSelect from '../components/DynamicSelect.js'
import {useRolePolicies} from '../hook/RolePoliciesHook.js'
import Bindcomponent from '../utils/bindcomponent.js';
const RolePolicies = () => {
  const {rowsUnits,message,tipe,role,columns,filter, ChangeRoles, selectedOptionRoles,setTipe,setmessage} = useRolePolicies();
  
  return (
    <Layout message={message} setmessage={setmessage} tipe={tipe} settipe={setTipe}>
    <div className='pd' ><b>GROUP ROLES POLICIES</b></div>
    <div className="pd">
    <div style={{marginBottom:10}}>
      <Bindcomponent component='DynamicSelect' label={"{kode} - {name}"} value={"kode"} selectedvalue={selectedOptionRoles}  onChange={(option) => {
          ChangeRoles(option)}} url={"GetRoles/" + role.toUpperCase()} id="roleSelect" disabled={false} required={false} filter={filter}></Bindcomponent>
      {/* <DynamicSelect label={"{kode} - {name}"} value={"kode"} selectedvalue={selectedOptionRoles}  onChange={(option) => {
          ChangeRoles(option)}} url={"GetRoles/" + role.toUpperCase()} id="roleSelect" disabled={false} required={false} filter={filter}>
      </DynamicSelect> */}
    </div>
  
    <Box sx={{ width: 1 }} >
      <Box   >
      <form>
        <Box >
          <Bindcomponent component='GridNumberPaging' customcolumns={columns} rows={rowsUnits} name={"statusgrid"} rowid={"name"}></Bindcomponent>
          {/* <GridNumberPaging customcolumns={columns} rows={rowsUnits} name={"statusgrid"} rowid={"name"}></GridNumberPaging> */}
        </Box>
      </form>
      </Box>
    </Box>
    </div>
  </Layout>
  );
};

export default RolePolicies;
